export default `<div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between">
                      <div>
                        <div style="font-size: 1.4rem; margin-bottom: 20px; text-align: center">
                          <strong>Explore Sample Templates</strong>
                        </div>

                        <div
                          style="display: flex; justify-content: center"
                        >
                          <ol style="width: 420px">
                            <li style="margin-top: 4px">
                              Click on the
                              <strong class="btn btn-success">
                                Templates Library
                              </strong>
                              at the <strong>left-top</strong> corner
                            </li>
                            <li style="margin-top: 4px">Select template to load</li>
                            <li style="margin-top: 4px">
                              Click
                              <strong class="btn btn-warning">
                                Run Template
                              </strong>
                              button
                            </li>
                            <li style="margin-top: 4px">Explore extracted data and fields</li>
                          </ol>
                        </div>
                      </div>

                      <div>
                        <strong>Quick Tip</strong>: try
                        <strong class="btn btn-primary">Add Object</strong> -
                        <strong>
                          Add FIELD mapped from Virtual Grid
                        </strong> 
                        to quickly map values to fields using visual layout.
                      </div>
                    </div>`;
